import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService, config } from '@fgb/core';
import { ProviderUiActionResponse } from '@fgb/core';
@Component({
  selector: 'fgb-ecash-result',
  templateUrl: 'ecash-result-page.component.html',
  styleUrl: 'ecash-result-page.component.scss',
})
export class EcashResultPageComponent implements OnInit {
  response = new ProviderUiActionResponse();
  private paymentService = inject(PaymentService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  titleKey = 'payment.results.title';
  titleDefault = 'Confirming your payment';
  descriptionKey = 'payment.results.description';
  descriptionDefault = 'Please wait and do not close this window.';

  ngOnInit() {
    this.readCopy();
    this.processCallBack();
  }

  processCallBack() {
    const purchaseOrderId = this.route.snapshot.queryParamMap.get('purchaseOrderId') || undefined;

    const callbackUrl = config.baseApiUrl + this.router.url;

    const params = {
      purchaseOrderId,
    };

    this.paymentService.completePayment(params, callbackUrl, '/ecash/success', '/ecash/failure');
  }

  /** Swaps in the card-linking copy when this is the /cardtoken/result route. */
  private readCopy(): void {
    if (!this.router.url.startsWith('/cardtoken')) {
      return;
    }

    this.titleKey = 'cardtoken.results.title';
    this.titleDefault = 'Linking your card';
    this.descriptionKey = 'cardtoken.results.description';
  }
}
